export const AiAssistants = {
  WORKFLOWS_AI_ASSISTANT: 'WORKFLOWS_AI_ASSISTANT'
};
export const AiGenerationRatings = {
  THUMBS_DOWN: 'THUMBS_DOWN',
  THUMBS_UP: 'THUMBS_UP'
};